'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = OptInFeedbackSuccessMessage;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIntl = require('react-intl');

var _baseAlerts = require('@bibliocommons/base-alerts');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function OptInFeedbackSuccessMessage(_ref) {
  var close = _ref.close;

  var timeout = setTimeout(close, 3000);
  var handleDismiss = function handleDismiss() {
    clearTimeout(timeout);
    close();
  };

  return _react2.default.createElement(
    _baseAlerts.AlertSuccess,
    { className: 'feedback-thanks' },
    _react2.default.createElement(_baseAlerts.AlertDismiss, { handleDismiss: handleDismiss }),
    _react2.default.createElement(_reactIntl.FormattedHTMLMessage, { id: 'opt_in_feedback_thanks' })
  );
}

OptInFeedbackSuccessMessage.propTypes = {
  close: _react2.default.PropTypes.func.isRequired
};


//////////////////
// WEBPACK FOOTER
// ./~/@bibliocommons/opt-in/lib/components/opt-in-feedback-success-message/components/OptInFeedbackSuccessMessage.component.js
// module id = 1436
// module chunks = 1